// Onboarding API — uses api.soempg.com with JWT Bearer token
import apiClient from './client';

export const onboardingAPI = {
  // User onboarding (authenticated via JWT)
  get: () => apiClient.get('/users/me/onboarding'),
  step: (stepId, stepIndex) =>
    apiClient.patch('/users/me/onboarding/step', { step_id: stepId, step_index: stepIndex }),
  skip: (reason = 'skipped_welcome') =>
    apiClient.patch('/users/me/onboarding/skip', { reason }),
  complete: () =>
    apiClient.patch('/users/me/onboarding/complete'),
  reset: () =>
    apiClient.patch('/users/me/onboarding/reset'),
  // Reinicio hecho POR UN ADMIN sobre OTRO usuario. Distinto de reset(),
  // que actúa sobre uno mismo (/me). Requiere super_admin.
  resetUser: (userId) =>
    apiClient.patch(`/users/${userId}/onboarding/reset`),

  // Admin stats — backend route lives under /api/users (#156, was 404).
  adminStats: () => apiClient.get('/users/admin/onboarding/stats'),

  // Tour global config — lives under /api/admin (extended_routes).
  getTourConfig: () => apiClient.get('/admin/tour-config'),
  setTourConfig: (enabled, mode, updatedBy) =>
    apiClient.put('/admin/tour-config', { tour_enabled: enabled, tour_mode: mode, updated_by: updatedBy }),
};
